import { render, staticRenderFns } from "./PromptInstallNotificationsDialog.vue?vue&type=template&id=e8d267b8&"
import script from "./PromptInstallNotificationsDialog.vue?vue&type=script&lang=js&"
export * from "./PromptInstallNotificationsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports